var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-2 -2 34 34",
    id: "_24_-_Save",
    "data-name": "24 - Save",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M31,10.652a3,3,0,0,0-.962-2.2L22.854,1.8A3,3,0,0,0,20.816,1H4A3,3,0,0,0,1,4V28a3,3,0,0,0,3,3H28a3,3,0,0,0,3-3Zm-2,0V28a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3H20.816a1,1,0,0,1,.68.266l7.183,6.652A1,1,0,0,1,29,10.652Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M17,2a1,1,0,0,0-1-1H7.6a1,1,0,0,0-1,1V4.667a3,3,0,0,0,3,3H14a3,3,0,0,0,3-3V2ZM15,3V4.667a1,1,0,0,1-1,1H9.6a1,1,0,0,1-1-1V3H15Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M23.215,22.667a3,3,0,0,0-3-3h-8.43a3,3,0,0,0-3,3V30a1,1,0,0,0,1,1h12.43a1,1,0,0,0,1-1Zm-2,0V29H10.785V22.667a1,1,0,0,1,1-1h8.43a1,1,0,0,1,1,1Z",
    transform: "translate(-1 -1)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.ee08c9f9.svg";
export { ForwardRef as ReactComponent };